export default function ({ store, error }) {
  if (store.state.user.userStatus !== 'acquirer') {
    return error({ message: 'Vous n\'avez pas les droits pour accéder à cette page, nous vous invitons à contacter votre responsable.', statusCode: '404' })
  }
}
